import AppService from "./app-service"

const path = "dashboard"

export default class DashboardService extends AppService {

  constructor() {
    super({ path })
  }

  certsCount(filter) {
    return this.http.post(`${path}/certs-count`, filter) 
  }

  customerCertsCount(filter) {
    return this.http.post(`${path}/customer-certs-count`, filter) 
  }
}